import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { products as productsAPI } from 'api';
import reducers, { getIsFetching } from './reducers';

const AddProductApiHOC = () => WrappedComponent => compose(
  connect(
    state => ({
      _addProductApiHOC_state: {
        isProductFetching: getIsFetching(state),
      },
    }),

    dispatch => ({
      _addProductApiHOC_actions: {
        postProduct: bindActionCreators(productsAPI.actions.postProduct, dispatch),
      },
    }),
  ),

  /* eslint-disable no-underscore-dangle */
  withProps(
    props => ({
      addProductApiHOC: {
        ...props._addProductApiHOC_state,
        ...props._addProductApiHOC_actions,
      },
    }),
  ),
  /* eslint-enable no-underscore-dangle */
)(WrappedComponent);

export { reducers };

export default AddProductApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/AddProductApiHOC/index.js